export default __webpack_public_path__ + "static/media/tour-5.fc6221aa.png";